module.exports = __webpack_public_path__ + "static/media/view3.a2e8f3c8.jpg";